//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "GradientChoice",

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
}
